<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工具包配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityIds" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                       :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品SPU">
          <!-- <el-input v-model="listQuery.spuCode" placeholder="请输入商品spu" clearable></el-input> -->
          <el-select v-model="listQuery.spuCode" clearable placeholder="请选择" filterable>
            <el-option v-for="(item, index) in goodsList" :key="index"
                       :label="item.spuCode + ' ' + item.commodityName" :value="item.spuCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工具包类型">
          <el-select v-model="listQuery.toolkitsType" clearable placeholder="请选择类型">
            <el-option v-for="(item, index)  in toolTypeMap" :key="index" :label="item" :value="index"/>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="listQuery.auditStatus" clearable placeholder="请选择状态">
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核拒绝" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="addToolBag">新增工具包配置</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px"></el-table-column>

        <el-table-column prop="cityName" label="城市">
          <template slot-scope="scope">
            {{ cityFmt(scope.row.cityId) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="postId" label="驿站" width="160" >
            <template slot-scope="scope">
                {{postStationFmt(scope.row.postId)}}
            </template>
        </el-table-column>
        <el-table-column prop="stationId" label="服务站">
            <template slot-scope="scope">
                {{postStationFmt(scope.row.stationId)}}
            </template>
        </el-table-column>  -->
        <el-table-column prop="kitName" label="名称"></el-table-column>
        <el-table-column prop="spuCode" label="工具包编号"></el-table-column>
        <el-table-column prop="toolkitsType" label="工具包类型">
          <template slot-scope="scope">
            {{ toolTypeMap[scope.row.toolkitsType] }}
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.auditStatus == 1">待审核</el-tag>
            <el-tag type="success" v-if="scope.row.auditStatus == 2">审核通过</el-tag>
            <el-tag type="danger" v-if="scope.row.auditStatus == 3">审核拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auditTime" label="审核时间"></el-table-column>
        <el-table-column prop="auditUserId" label="审核人id"></el-table-column>
        <el-table-column prop="auditRemark" label="审核备注"></el-table-column>
        <el-table-column prop="isDelete" label="是否删除">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.isDelete == 1">已删除</el-tag>
            <el-tag type="success" v-else>未删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="180px" align="center">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="delTool(scope.row)"
                       v-if="scope.row.isDelete == 0 && scope.row.auditStatus == 2" class="red"
                       size="mini">删除
            </el-button>
            <el-button type="success" plain @click="shenpi(scope.row)"
                       v-if="scope.row.auditStatus == 1 && scope.row.isDelete == 0" size="mini">审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch"/>
    </el-card>

    <!-- 新增工具包配置 -->
    <el-dialog title="新增工具包配置" :visible.sync="addToolBagVisible" width="600px" :close-on-click-modal="false"
               center>
      <el-form ref="addToolBagForm" :rules="addRules" label-width="160px" :model="addToolBagForm" size="medium">
        <el-row>
          <el-form-item label="商品工具包名称" prop="configName">
            <el-input v-model="addToolBagForm.configName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="工具包类型" prop="toolkitsType">
            <el-select v-model="addToolBagForm.toolkitsType" clearable placeholder="请选择类型">
              <el-option v-for="(item, index)  in toolTypeMap" :key="index" :label="item" :value="index"/>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="城市" prop="cityIds">
            <el-select v-model="addToolBagForm.cityIds" clearable @change="getGoods" placeholder="请选择城市"
                       filterable>
              <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
                         :value="item.id + ''"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="商品工具包spu编号" prop="spuCode">
            <el-select v-model="addToolBagForm.spuCode" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in goodsList" :key="index"
                         :label="item.spuCode + ' ' + item.commodityName" :value="item.spuCode"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <br/><br/>
        <el-row style="color:red">{{ errMsg }}</el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="addToolBagVisible = false">取 消</el-button>
                <el-button type="primary" @click="confaddToolBag('addToolBagForm')">确 定</el-button>
            </span>
    </el-dialog>

    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="isShowAduit" width="600px" :close-on-click-modal="false" center>
      <el-form label-width="160px" :model="addToolBagForm" size="medium">
        <el-form-item label="审核结果">
          <el-select v-model="auditForm.auditStatus" placeholder="请选择">
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核拒绝" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核原因">
          <el-input v-model="auditForm.auditRemark" placeholder="请输入原因" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="isShowAduit = false">取 消</el-button>
                <el-button type="primary" @click="confAudit()">确 定</el-button>
            </span>
    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";

export default {
  components: {Pagination},
  data() {
    return {
      toolTypeMap: {
        1: '上线包',
        2: '晋升包',
        3: "月度包",
      },
      auditForm: {
        id: '',
        auditStatus: '',
        auditRemark: ''
      },
      isShowAduit: false,
      errMsg: '',
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        cityId: '',
        spuCode: '',
        toolkitsType: '',
        auditStatus: ''

      },
      cityList: [],
      postStationList: [],
      allStationList: [],

      goodsList: [],

      addToolBagVisible: false,
      addToolBagForm: {
        configName: '',
        cityIds: [],
        spuCode: "",
        toolkitsType: 1,
        createUserId: ""
      },
      addRules: {
        configName: [{
          required: true,
          message: "请输入工具包名称",
          trigger: "change",
        }],
        cityIds: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        // stationIds: [
        //   { required: true, message: "请选择服务站", trigger: "change" }
        // ],
        cityIds: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        spuCode: [
          {
            required: true,
            message: "请选择商品工具包spu编号",
            trigger: "change",
          },
        ],
        toolkitsType: [
          {
            required: true,
            message: "请选择工具包类型",
            trigger: "change",
          },
        ],
      },

    };
  },
  created() {
    this.querySearch();
    this.getAllCityList();
    // this.getGoods();
    // this.getAllPostStation();
    // this.getAllStationList();
  },
  methods: {
    getGoods(cityid) {
      wmsApi
        .$axiosCommodityList({
          type: 1,
          page: 1,
          size: 999,
          cityId: cityid,
        })
        .then((res) => {
          this.goodsList = res.data.data.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confAudit() {
      if (this.auditForm.auditStatus == 3 && this.auditForm.auditRemark == '') {
        this.$message.error("请输入审核原因");
        return;
      }
      wmsApi.$axiosAuditPackageTool(this.auditForm)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.isShowAduit = false;
            this.querySearch();
          }
        });
    },
    shenpi(row) {
      this.isShowAduit = true;
      this.auditForm = {
        id: row.id,
        auditStatus: 2,
        auditRemark: ''
      }
    },
    delTool(row) {
      //删除工具包
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          wmsApi.$axiosdeletePackageTool({
            id: row.id,
          })
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.querySearch();
              }
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //查询
    querySearch() {
      let temp = {
        page: this.currentPage,
        size: this.pageSize,
        cityId: this.listQuery.cityId,
        spuCode: this.listQuery.spuCode,
        toolkitsType: this.listQuery.toolkitsType,
        auditStatus: this.listQuery.auditStatus,
      };
      wmsApi
        .$axiosGetPackageTool(temp)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAllCityList() {
      wmsApi
        .$axiosCityStationGetAll({})
        .then((res) => {
          this.cityList = res.data.data;
          if (this.cityList.length > 0 && this.cityList[0].cityName == '全国') {
            this.cityList.shift();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllPostStation() {
      //驿站
      workercrmapi
        .$axiosPostStationgetAllList({userId: globalData.userInfo.id})
        .then((res) => {
          if (res.data.errno == 0) {
            this.postStationList = res.data.data;
          }
        });
    },
    getAllStationList() {
      //服务站
      wmsApi
        .$axiosGetAllStationList({userId: globalData.userInfo.id})
        .then((res) => {
          if (res.data.errno == 0) {
            this.allStationList = res.data.data;
          }
        });
    },
    addToolBag() {
      this.addToolBagVisible = true;
      this.addToolBagForm = {
        configName: '',
        cityIds: [],
        spuCode: "",
        toolkitsType: '1',
        createUserId: globalData.userInfo.id
      };
      this.loadGoodsPackage();
    },
    loadGoodsPackage(cityId) {
      let temp = {
        page: 1,
        size: 200,
        type: 1,
        status: 4,
        cityId: cityId
      };
    },
    confaddToolBag(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.errMsg = '';
          this.addToolBagForm.cityIds = this.addToolBagForm.cityIds ? [this.addToolBagForm.cityIds] : [];
          console.log("this.addToolBagForm", JSON.stringify(this.addToolBagForm));
          wmsApi.$axiossetPackageTool(this.addToolBagForm).then((res) => {
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addToolBagVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.errmsg);
            }
          }).catch((r) => {
            this.errMsg = r.data.errmsg;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    cityFmt(cityId) {
      // console.log(cityId);
      let name = "";
      if (cityId != null) {
        let c = this.cityList.forEach((e) => {
          if ((cityId + ',').indexOf(e.id + ',') != -1) {
            name = e.cityName + ',' + name;
          }
        });
      }
      return name;
    },
    postStationFmt(postId) {
      // console.log(cityId);
      let name = "";
      if (postId != null) {
        let c = this.postStationList.forEach((e) => {
          if (e.id == postId) {
            name = e.postStationName;
          }
        });
      }
      return name;
    },
    stationFmt(stationId) {
      // console.log(cityId);
      let name = "";
      if (cityId != null) {
        let c = this.allStationList.forEach((e) => {
          if (e.id == stationId) {
            name = e.stationName;
          }
        });
      }
      return name;
    },
  },
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}</style>
